class ItemPlannerItem {

    constructor(
        $scope,
        $rootScope,
        $mdDialog,
        $http,
        $mdToast,
        $state,
        selector,
    ) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$mdDialog = $mdDialog;
        this.$http = $http;
        this.$mdToast = $mdToast;
        this.$state = $state;
        this.selector = selector;

        $scope.$on('$destroy', this.destroy.bind(this));

        $scope.$on('item-planner_item-update_' + $scope.item.id, (event, savedItem) => {
            $scope.$applyAsync(() => {
                Object.assign($scope.item, savedItem);
            });
        });
    }

    onItemClick($event) {
        const {selector, $scope} = this;
        const {item, broadcast} = $scope;

        if ($event.ctrlKey || $event.shiftKey) {
            selector.toggleSelectionValue(item);
            return;
        }

        // if ($event.shiftKey) {}

        this.$state.go('rundown.edit', {
            itemId: item.id,
            blockId: item.block_id,
            program: broadcast.program_id,
            broadcast: broadcast.id,
            type: 'block',
        }, {reload: true});
    }

    startDragging(event) {
        const {$scope, $rootScope, selector} = this;
        const {item, broadcast} = $scope;

        selector.addItemWhenNotInSelection(item, true);

        $rootScope.itemPlannerDndActive = true;
        $rootScope.$broadcast('item-planner_show-broadcast', broadcast.id);
        $rootScope.itemPlannerCurrentBroadcast = broadcast.id;

        event.dataTransfer.setDragImage(event.target.children[0], 0, 0);
    }

    stopDragging() {
        const {$rootScope, selector} = this;
        $rootScope.itemPlannerDndActive = false;
        $rootScope.$broadcast('item-planner_show-broadcast', null);
        selector.clearSelection();
    }

    destroy() {
        //
    }

    deleteItem(item, event) {
        event.stopPropagation();

        this.$mdDialog.show({
            controller: 'ConfirmDialogCtrl',
            templateUrl: 'confirmDialog.ngTemplate',
            parent: angular.element(document.querySelector('#popupContainer')),
            targetEvent: event,
            clickOutsideToClose: true
        }).then(() => {
            this.$http.delete('/items/' + item.id).then(() => {
                this.$rootScope.$broadcast('item-planner_remove-item_block_' + item.block_id, item);
                this.$mdToast.show({
                    templateUrl: '/partial/app.partials.toasts.delete?object=item&title=' + item.title,
                    hideDelay: 6000,
                    position: ('top right'),
                });
            });
        });
    }

    createItemAfter(afterItem) {
        this.$state.go('item-planner.item-create', {
            afterItemId: afterItem.id,
            blockId: afterItem.block_id,
            createInDate: moment(afterItem.start).format('YYYY-MM-DD'),
        });
    }

    editCurrentItem(item) {
        this.$state.go('item-planner.item-update', {
            itemId: item.id,
        });
    }
}

export default [() => {
    return {
        templateUrl: '/partial/app.partials.item-planner.directives.item',
        replace: true,
        controller: [
            '$scope',
            '$rootScope',
            '$mdDialog',
            '$http',
            '$mdToast',
            '$state',
            'itemPlannerSelection',
            ItemPlannerItem,
        ],
        controllerAs: 'ctrl',
        scope: {
            item: '=',
            broadcast: '=',
        },
    };
}];
